import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { toast, ToastContainer } from "react-toastify";

import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";

import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { common_axios } from "../../../../App";
import { dateFormatter } from "../../../../helper/helper";
export default function CallerID() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([
    {
      MobileNo: 8189896533,
    },
    {
      MobileNo: 8189896533,
    },
    {
      MobileNo: 8189896533,
    },
  ]);

  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);

  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/reseller/v1/senderids`
        // {
        //   approved: filter.approveType,
        //   userId: JSON.parse(localStorage.getItem("items")).uid,
        //   type: filter.type,
        // }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData(res.data.listSenderIdRequest);
        setOpen(false);
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      await toast.error("Something went wrong!! Please check your Network", {
        theme: "colored",
      });
      console.log(error);
    }
  };

  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },
      {
        Header: "Mobile No",

        accessor: "MobileNo",
      },

      {
        Header: "Assigned Date",

        accessor: "creationDate",
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.creationDate)}</>;
        },
      },

      //   {
      //     Header: "User-Action",
      //     Footer: "User-Action",
      //     accessor: "action",
      //     Cell: (cell) => (
      //       <div className="dropdown">
      //         <button
      //           className="btn color_1 dropdown-toggle"
      //           type="button"
      //           id="dropdownMenuButton1"
      //           data-bs-toggle="dropdown"
      //           aria-expanded="false"
      //         >
      //           <i className="material-icons opacity-10 size">person</i>
      //         </button>
      //         <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
      //           <li>
      //             <a
      //               className="dropdown-item"
      //               onClick={() => {
      //                 approveUserModal(cell);
      //               }}
      //             >
      //               View Details
      //             </a>
      //           </li>
      //         </ul>
      //       </div>
      //     ),

      //     disableFilters: true,
      //   },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetailApprove != undefined && (
        <>
          <button
            type="button"
            ref={modelButtonApprove}
            class="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <form>
            <div
              class="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">
                      Modal title
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row">
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Id:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.id}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>

                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Sender Id :
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.senderId}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT Id:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.dltId || "-------"}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={
                            selectedUserDetailApprove?.category || "-------"
                          }
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <i className="material-icons opacity-10">person</i>
            </div>
            <div className="text-end pt-1">
              <p
                className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                style={{ marginRight: "960px" }}
              >
                Voice Caller Id
              </p>
            </div>
          </div>

          {data.length > 0 ? (
            <div className="card-body">
              <div className="text-end">
                {selectedFlatRows.length > 0 && (
                  <button
                    onClick={deletUser}
                    className="btn bg-gradient-primary m-0"
                  >
                    Delete Users
                  </button>
                )}
              </div>

              <table
                {...getTableProps()}
                id="example"
                className="table table-striped table-bordered dataTable table-sm mt-3"
                style={{ width: "100%" }}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          className="text-center width_2"
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? "↑"
                                : "↓"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="text-center"
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    Page:
                    <strong>
                      {pageIndex + 1} of {pageOptions.length}
                    </strong>
                  </span>
                </div>

                <div>
                  <span>
                    Go to Page :{""}
                    <input
                      type="number"
                      value={pageIndex + 1}
                      onChange={(e) => {
                        const pageNumber = e.target.value
                          ? Number(e.target.value) - 1
                          : 0;
                        gotoPage(pageNumber);
                      }}
                      style={{ width: "50px" }}
                    />
                  </span>
                </div>

                <div id="Nikhil">
                  <button
                    className="btn btn_primary m-0 ms-2"
                    type="button"
                    style={{
                      background: "#2C97D4",
                    }}
                    disabled={!canPreviousPage}
                    onClick={() => {
                      previousPage();
                    }}
                  >
                    Prev
                  </button>

                  <button
                    className="btn btn_primary m-0 ms-2"
                    type="button"
                    style={{
                      background: "#2C97D4",
                    }}
                    disabled={!canNextPage}
                    onClick={() => {
                      nextPage();
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body">
              <div>
                <h5
                  // className="text-align-between"
                  style={{ textAlign: "center" }}
                >
                  No Data Available
                </h5>
              </div>
            </div>
          )}
          {/* <div className="text-end mb-3 me-3">
            <p> Add Sender Id </p>
            <Link
              to="/dashboard/Reseller/AddSender"
              style={{ color: "#63B7E6", marginLeft: "30px" }}
            >
              <span>Click here !!!</span>
            </Link>
          </div> */}
        </div>
      </div>
    </main>
  );
}
